module.exports = __webpack_public_path__ + "img/9788989571599.81210654.jpg";